import { render, staticRenderFns } from "./oomHome.vue?vue&type=template&id=2661a4e9&scoped=true"
import script from "./oomHome.vue?vue&type=script&lang=js"
export * from "./oomHome.vue?vue&type=script&lang=js"
import style0 from "./oomHome.vue?vue&type=style&index=0&id=2661a4e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2661a4e9",
  null
  
)

export default component.exports